export default __webpack_public_path__ + "static/media/logo-header.da2e3e96.png";